module.exports = __webpack_public_path__ + "img/frontend_base_maritima.222058e0.jpg";